import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("wq_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const setToken = (token) => {
  if (token) localStorage.setItem("wq_token", token);
  else localStorage.removeItem("wq_token");
};

export const getToken = () => localStorage.getItem("wq_token");

export const mediaUrl = (path) => (path?.startsWith("/api/") ? `${BACKEND_URL}${path}` : path);
